import React from "react";
import {
  NEXT_DAY_END_HOURS,
  formatShiftEndValue,
  parseShiftEndValue,
  nextDayEndHourLabel,
} from "../shiftTimeUtils";

export const SHIFT_MINUTE_OPTIONS = ["00", "15", "30", "45"];

const timeDropdownSelectStyle = {
  padding: "6px 8px",
  borderRadius: 8,
  border: "1.5px solid var(--border)",
  fontSize: 13,
  fontWeight: 600,
  background: "var(--surface2)",
  color: "var(--text-primary)",
  fontFamily: "DM Sans, sans-serif",
  cursor: "pointer",
};

export function parseShiftTimeParts(val, fallback = "09:00") {
  const parsed = parseShiftEndValue(val, fallback);
  const [h, m] = parsed.time.split(":");
  const hour = String(h || "09").padStart(2, "0");
  const minRaw = String(m || "00").slice(0, 2);
  const minute = SHIFT_MINUTE_OPTIONS.includes(minRaw) ? minRaw : "00";
  return { hour, minute, nextDay: parsed.nextDay };
}

export function TimeDropdownSelect({
  value,
  onChange,
  label,
  labelClassName,
  labelStyle,
  disabled = false,
  allowNextDayEnds = false,
  lang = "en",
}) {
  const { hour, minute, nextDay } = parseShiftTimeParts(value);
  const hourSelectValue = allowNextDayEnds && nextDay ? `${hour}+1` : hour;
  const defaultLabelStyle = {
    fontSize: 10,
    fontWeight: 700,
    color: "var(--text-muted)",
    display: "block",
    marginBottom: 3,
  };

  const emitTime = (nextHourRaw, nextMinute, forceNextDay) => {
    const raw = String(nextHourRaw);
    const isNext = forceNextDay != null ? forceNextDay : raw.endsWith("+1");
    const h = raw.replace(/\+1$/, "").padStart(2, "0");
    onChange(formatShiftEndValue(`${h}:${nextMinute}`, Boolean(isNext)));
  };

  return (
    <div>
      {label ? (
        labelClassName ? (
          <label className={labelClassName}>{label}</label>
        ) : (
          <label style={labelStyle || defaultLabelStyle}>{label}</label>
        )
      ) : null}
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <select
          value={hourSelectValue}
          onChange={(e) => emitTime(e.target.value, minute)}
          disabled={disabled}
          style={{
            ...timeDropdownSelectStyle,
            width: allowNextDayEnds ? 118 : 52,
            opacity: disabled ? 0.6 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          {Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0")).map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
          {allowNextDayEnds
            ? NEXT_DAY_END_HOURS.map((hNum) => {
                const h = String(hNum).padStart(2, "0");
                return (
                  <option key={`${h}+1`} value={`${h}+1`}>
                    {nextDayEndHourLabel(h, lang)}
                  </option>
                );
              })
            : null}
        </select>
        <span style={{ fontWeight: 700, color: "var(--text-muted)", fontSize: 13 }}>:</span>
        <select
          value={minute}
          onChange={(e) => emitTime(hourSelectValue, e.target.value, nextDay)}
          disabled={disabled}
          style={{
            ...timeDropdownSelectStyle,
            width: 52,
            opacity: disabled ? 0.6 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          {SHIFT_MINUTE_OPTIONS.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
